import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaOperadoraIngreso', {
    template: template,
    controller: nominaOperadoraIngresoComponent,
    bindings: {
      idProyecto: '<',
      idNomina: '<',
    },
  })

function nominaOperadoraIngresoComponent(NominaOperadoraIngreso) {
  let $ctrl = this

  $ctrl.$onInit = $onInit

  function $onInit() {
    $ctrl.promise = NominaOperadoraIngreso.get($ctrl.idProyecto, $ctrl.idNomina, $ctrl.parcial)
      .then(function (response) {
        $ctrl.data = response.data
      })
  }
}



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/operadora/ingreso/component.js